import { Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useUserOrganization } from '@/hooks/useUserOrganization'
import { Sidebar } from './Sidebar'

function getInitials(email: string | undefined): string {
  if (!email) return '?'
  const name = email.split('@')[0]
  const parts = name.split(/[._-]/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

export function AppLayout() {
  const { user, signOut } = useAuth()
  const { data: membership } = useUserOrganization()

  const orgName = membership?.core_organizations?.name ?? 'Admin'

  return (
    <div className="min-w-[1200px] h-screen flex flex-col">
      {/* Topbar */}
      <header className="sticky top-0 z-50 flex items-center justify-between px-6 py-3.5 bg-white border-b border-gray-200/80">
        <span className="text-lg font-bold text-gray-900 tracking-wide">
          {orgName.toUpperCase()}
        </span>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <div className="w-8 h-8 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center text-[13px] font-semibold">
              {getInitials(user?.email)}
            </div>
            <span>{user?.email?.split('@')[0] ?? 'Bruker'}</span>
          </div>
          <button
            onClick={signOut}
            className="text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            Logg ut
          </button>
        </div>
      </header>

      {/* Sidebar + Content */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
